var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "avue-contail u-relative",
      class: { "avue--collapse": _vm.isCollapse },
    },
    [
      !_vm.difChannelType.isFullScreen
        ? _c("div", [
            _c("div", { staticClass: "avue-header" }, [_c("top")], 1),
            _c("div", { staticClass: "avue-layout" }, [
              _c("div", { staticClass: "avue-left" }, [_c("sidebar")], 1),
              _c(
                "div",
                { staticClass: "avue-main" },
                [
                  _c("tags"),
                  _c(
                    "transition",
                    { attrs: { name: "fade" } },
                    [
                      _c("NoticesHint", {
                        ref: "refNoticesHint",
                        attrs: { isShow: _vm.isShowHint },
                        on: {
                          "update:isShow": function ($event) {
                            _vm.isShowHint = $event
                          },
                          "update:is-show": function ($event) {
                            _vm.isShowHint = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "overflow-y": "auto",
                        "overflow-x": "hidden",
                      },
                      style: _vm.isShowHint
                        ? { height: "calc(100% - 80px)" }
                        : { height: "calc(100% - 40px)" },
                      attrs: { id: "avue-view" },
                    },
                    [
                      _c(
                        "keep-alive",
                        [
                          _vm.$route.meta.keepAlive
                            ? _c("router-view", {
                                key: _vm.$route.fullPath,
                                staticClass: "avue-view",
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      !_vm.$route.meta.keepAlive
                        ? _c("router-view", { staticClass: "avue-view" })
                        : _vm._e(),
                      _vm._l(_vm.getIframeTagList, function (iframeItem) {
                        return _c(
                          "div",
                          { key: iframeItem.value },
                          [
                            _c("entry-center-url", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.$route.fullPath === iframeItem.value,
                                  expression:
                                    "$route.fullPath === iframeItem.value",
                                },
                              ],
                              attrs: { "iframe-url": iframeItem.value },
                            }),
                          ],
                          1
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ])
        : _c(
            "div",
            {
              staticStyle: {
                height: "calc(100%)",
                "overflow-y": "auto",
                "overflow-x": "hidden",
              },
            },
            [
              _c(
                "keep-alive",
                [
                  _vm.$route.meta.keepAlive
                    ? _c("router-view", {
                        key: _vm.$route.fullPath,
                        staticClass: "avue-view",
                      })
                    : _vm._e(),
                ],
                1
              ),
              !_vm.$route.meta.keepAlive
                ? _c("router-view", { staticClass: "avue-view" })
                : _vm._e(),
            ],
            1
          ),
      _c("div", { staticClass: "avue-shade", on: { click: _vm.showCollapse } }),
      _vm.isShowUpdate
        ? _c("div", { staticClass: "update-hint" }, [
            _c("div", { staticClass: "hint-header" }, [
              _c(
                "div",
                { staticClass: "warning-icon" },
                [_c("el-icon", { staticClass: "el-icon-warning" })],
                1
              ),
              _c("span", { staticClass: "hint-title" }, [_vm._v("提示")]),
            ]),
            _c("div", { staticClass: "hint-content" }, [
              _vm._v("检测到新版本，请及时更新！"),
            ]),
            _c(
              "div",
              { staticClass: "hint-footer" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "update-btn",
                    attrs: { type: "primary" },
                    on: { click: _vm.handleUpdate },
                  },
                  [_vm._v("更新")]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _c("FrequentQuestions"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }